/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `Payload` type.
 */

type Payload = {
  title: string;
  body: string;
  sound: boolean;
  userId: string;
};

/**
 * Change user custom notification.
 */

export function postUserCustomNotification(client: AxiosInstance, payload: Payload): Promise<void> {
  console.log('###', {
    title: payload.title,
    body: payload.body,
    sound: payload.sound
  });

  return client
    .post(resolveAppUrl('userCustomNotification', { interpolations: { userId: payload.userId } }), {
      title: payload.title,
      body: payload.body,
      sound: payload.sound
    })
    .then(({ data }) => data);
}

/**
 * Export `usePosUserCustomNotification`.
 */

export function usePosUserCustomNotification() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await postUserCustomNotification(client, payload);
    }
  });
}
